import {Group, GroupMember, GroupMemberRoleType, RoomParty, TourRoleType} from '../../../../graphql/groups.datatypes';
import {makeStyles} from '@material-ui/styles';
import React from 'react';
import {Card, CardContent, CardHeader, colors, Divider, Grid, Theme, Typography} from '@material-ui/core';
import {formatDate} from '../../../../utils/formatters';
import {Resource} from '../../../../graphql/resources.datatypes';
import {getBlankGroup} from '../../GroupDetails/GroupDetails';
import getGroupWithQuery from '../../getGroupWithQuery.api';
import {gqlGroupForHotelOverviewCardQuery} from '../../getGroupQueries.api';
import {T} from 'react-polyglot-hooks';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    card: {},
    saveButton: {
        marginLeft: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        }
    },
    deleteButton: {
        marginLeft: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: theme.palette.error.light,
        '&:hover': {
            backgroundColor: theme.palette.error.main
        }
    },
    cloneButton: {
        marginLeft: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: colors.green[400],
        '&:hover': {
            backgroundColor: colors.green[700]
        }
    },
    errorIcon: {
        marginRight: theme.spacing(1),
        color: theme.palette.error.main,
    },
    marginBottom: {
        paddingLeft: theme.spacing(1),
        marginBottom: theme.spacing(3),
    },
    tabs: {
        marginTop: theme.spacing(3)
    },
}));


const HotelsOverviewCard = (props: { group: Group, isAdmin: boolean }) => {
    const {group, isAdmin} = props;
    const classes = useStyles();
    const isNewGroup = group.id === -1;
    const groupForHotelOverviewCardData = isNewGroup ? {loading: false, data: {group: getBlankGroup()}, error: null} : getGroupWithQuery(Number(group.id), gqlGroupForHotelOverviewCardQuery);
    const groupForHotelOverviewCard = groupForHotelOverviewCardData && !groupForHotelOverviewCardData.loading && groupForHotelOverviewCardData.data && groupForHotelOverviewCardData.data.group;
    const roomParties = groupForHotelOverviewCard && groupForHotelOverviewCard.bookings ? groupForHotelOverviewCard.bookings.reduce((arr: RoomParty[], booking) => !booking.roomParties ? arr : [...arr, ...booking.roomParties], []) : [];
    const hotels = groupForHotelOverviewCard && roomParties ? roomParties.reduce((arr: Resource[], roomParty) => !roomParty.hotel || arr.find(hotel => hotel.id === roomParty.hotel!.id) ? arr : [...arr, roomParty.hotel], []) : [];

    return (
        <React.Fragment>
            <Card className={classes.container}>
                <CardHeader title={'Hotels Overview'}/>
                <Divider/>
                <CardContent className={classes.card}>
                    <Grid container alignItems="center" spacing={1}>
                        {groupForHotelOverviewCardData.loading && (
                            <React.Fragment>
                                <Grid item xs={4}>
                                    <Typography><T phrase="Loading..."/></Typography>
                                </Grid>
                            </React.Fragment>
                        )}
                        {groupForHotelOverviewCard && !groupForHotelOverviewCardData.loading && (
                            <React.Fragment>
                                {hotels && (
                                    <React.Fragment>
                                        {hotels.length === 0 && (
                                            <Grid item xs={4}>
                                                <Typography><T phrase="No hotel information to show"/></Typography>
                                            </Grid>
                                        )}
                                        {hotels.length > 0 && hotels.map(hotel => {
                                            const allRooms = roomParties.filter(room => room.hotel_resource_id === hotel.id);

                                            return allRooms && allRooms.length > 0 && (
                                                <Grid key={hotel.id} item xs={12}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h4">{isAdmin ? hotel.internal_name : hotel.display_name}</Typography>
                                                        </Grid>

                                                        {hotel.roomResources && hotel.roomResources.map(roomResource => {
                                                            const rooms = roomParties.filter(room => room.roomResource!.room_resource_id === roomResource.id);

                                                            return rooms && rooms.length > 0 && (
                                                                <Grid key={roomResource.id} item xs={6}>
                                                                    <Grid container spacing={1}>
                                                                        {isAdmin && (
                                                                            <React.Fragment>
                                                                                <Grid item xs={4}>
                                                                                    <Typography variant="body1">Room Type:</Typography>
                                                                                </Grid>
                                                                                <Grid item xs={8}>
                                                                                    <Typography variant="body1">{roomResource.internal_name}</Typography>
                                                                                </Grid>
                                                                            </React.Fragment>
                                                                        )}
                                                                        <Grid item xs={4}>
                                                                            <Typography variant="body1"># Rooms:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs={8}>
                                                                            <Typography variant="body1">{rooms ? rooms.length : 0}</Typography>
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            <Typography variant="body1">Total Occupants:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs={8}>
                                                                            <Typography variant="body1">{rooms ? rooms.reduce((total, room) => total + room.members!.length, 0) : 0}</Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            );
                                                        })}
                                                    </Grid>
                                                </Grid>
                                            )
                                        })}
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )}
                    </Grid>
                </CardContent>
            </Card>
        </React.Fragment>
    );
};

export default HotelsOverviewCard;
